import React from "react";
import { connect } from "react-redux";
import { goBack } from "react-router-redux";
import { KerberosForm, DevLoginForm } from "../../../components/forms/LoginForms";
import { kerberosLoginAction, loginAction } from "../../../../../utils/login";
import PublicPage from "../../../components/PublicPage";

const ConnectedKerberosForm = connect(null, {
  onSubmit: kerberosLoginAction(
    "/spravce/api/auth/kerberos",
    "/spravce/funkcionari",
  ),
  goBack,
})(KerberosForm);

const ConnectedDevForm = connect(null, {
  onSubmit: loginAction(
    "/opravneny-organ/api/auth/basic",
    "/spravce/funkcionari",
  ),
  goBack,
})(DevLoginForm);

const InternalLogin = () => (
  <PublicPage title="Přihlášení správce">
    <ConnectedKerberosForm title="Přihlášení správce" />
    {(process.env.NODE_ENV !== "production" || process.env.REACT_APP_DEV_LOGIN === "true") && <ConnectedDevForm />}
  </PublicPage>
);

export default InternalLogin;
